const images = {
  logoWhite: require('../assets/images/fnb.svg'),
  logoBlack: require('../assets/images/fnb.svg'),
  landingBackground: require('../assets/images/main-bg.png'),
  underConstruction: require('../assets/images/under-construction.svg'),
  warning: require('../assets/images/warning.svg'),
  empty: require('../assets/images/babor-empty.svg'),
  whiteRose: require('../assets/images/white-rose.png'),
  pinkRose: require('../assets/images/pink-rose.png'),
  blackRose: require('../assets/images/black-rose.png')
}

export default images
